export const environment = {
    baseUrl: 'https://holy.kawla-dev.com',
    auth: {
        username: 'anasser',
        password: 'Ahmnas@1976'
    }
};
